import styled from "styled-components"

export const WriteFormFieldsContainer = styled.div<{ withTopMargin?: boolean }>`
    margin-top: ${({ withTopMargin }) => (withTopMargin ? "-10px" : "0")};
`
